<span *ngIf="!!activity" class="input-group input-group-sm" style="max-width: 100px !important">
  <span class="input-group-text bg-transparent">
    <fa-icon [icon]="faHashtag" class="text-secondary"></fa-icon>
  </span>
  <input id="orsGO" #orsGO type="text" inputmode="numeric" pattern="[0-9]*" min="1" step="1" (keyup.enter)="orsGOTO()" [(ngModel)]="ors_id" class="form-control form-control-sm border-left-0 nospinner">
</span>
